export default {
  // Brand & meta
  "brand.name": "USFansLink",
  "brand.tagline": "Centre de ressources indépendant USFans Spreadsheet",
  "meta.home.title": "USFans Spreadsheet : guides, avis, livraison et nouveautés",
  "meta.home.description": "Découvrez la USFans Spreadsheet : guides produits, conseils QC, informations de livraison, ressources d'entrepôt, avis et dernières actualités USFans.",
  "meta.article.title": "Guide USFans Spreadsheet : ce que c'est et comment l'utiliser",
  "meta.article.description": "Un guide complet et indépendant de la USFans Spreadsheet : fonctionnement, recherche de produits, conseils par catégorie, contrôles QC, livraison et sécurité de base.",

  // Navigation
  "nav.home": "Accueil",
  "nav.guide": "Guide USFans Spreadsheet",
  "nav.buyingGuide": "Guide d'achat",
  "nav.categories": "Catégories",
  "nav.faq": "FAQ",
  "nav.explore": "Explorer la feuille",

  // Hero
  "hero.badge": "Centre de ressources indépendant",
  "hero.title": "USFans Spreadsheet : trouvez produits, guides et ressources plus vite",
  "hero.subtitle": "Votre ressource indépendante sur la USFans Spreadsheet : recherche de produits, guides QC, informations de livraison, conseils d'entrepôt et avis USFans.",
  "hero.supporting": "Vous cherchez la USFans Spreadsheet ? Commencez ici. Explorez des ressources produits organisées, apprenez à rechercher des produits, comprenez les informations QC, comparez les options et prenez de meilleures décisions avant d'acheter.",
  "hero.cta.primary": "USFans Spreadsheet",
  "hero.cta.secondary": "Acheter maintenant",
  "hero.cta.guide": "Lire le guide USFans",
  "hero.trust": "Ressources mises à jour · Guides indépendants · Informations axées sur la sécurité",

  // Category dropdown
  "categories.dropdown.label": "Parcourir les catégories",
  "categories.dropdown.hint": "Sélectionnez une catégorie pour l'ouvrir sur le site principal",

  // Category names
  "cat.shoes": "Chaussures",
  "cat.hoodies": "Sweats / Pulls",
  "cat.tshirts": "T-shirts",
  "cat.jackets": "Vestes",
  "cat.pants": "Pantalons / Shorts",
  "cat.headwear": "Couvre-chefs",
  "cat.sets": "Ensembles",
  "cat.underwear": "Sous-vêtements",
  "cat.jersey": "Maillots",
  "cat.accessories": "Accessoires",
  "cat.bags": "Sacs",
  "cat.belts": "Ceintures",
  "cat.perfumes": "Parfums",
  "cat.other": "Autres articles",

  // Categories section
  "categories.title": "Catégories de produits populaires",
  "categories.subtitle": "Accédez directement à une catégorie sur le site principal. Chaque bouton ouvre la page produit correspondante.",

  // About section
  "about.title": "Qu'est-ce que la USFans Spreadsheet ?",
  "about.body": "La USFans Spreadsheet est une ressource de découverte et de recherche de produits. Elle aide les utilisateurs à organiser les informations produits, à parcourir les catégories et à rechercher des produits avant de prendre une décision d'achat. Au lieu de sauter entre des pages dispersées, vous pouvez consulter les articles, comparer les options et vérifier les détails au même endroit.",
  "about.body2": "Notre mission chez USFansLink est de faciliter ce processus. Nous publions des guides indépendants et accessibles aux débutants qui expliquent comment fonctionne la feuille, comment lire les informations produits et ce qu'il faut vérifier avant de dépenser votre argent.",

  // Why section
  "why.title": "Pourquoi utiliser nos ressources USFans ?",
  "why.subtitle": "Tout ce qui se trouve ici est écrit pour vous aider à rechercher avec plus de confiance, sans vous orienter vers un seul vendeur.",
  "why.items": [
    "Informations organisées",
    "Guides pour débutants",
    "Tutoriels de recherche de produits",
    "Explications QC",
    "Informations de livraison",
    "Guides d'entrepôt",
    "Ressources d'avis",
    "Connaissance des coupons",
    "Informations de sécurité",
    "Mises à jour régulières"
  ],

  // Guide section
  "guide.title": "Comment utiliser la USFans Spreadsheet",
  "guide.body": "Quelques habitudes simples rendent la recherche de produits beaucoup plus rapide. Voici un flux de travail direct que vous pouvez suivre, que vous soyez un premier acheteur ou un chercheur régulier.",
  "guide.steps": [
    "Choisissez une catégorie qui correspond à ce que vous recherchez.",
    "Utilisez la recherche et les filtres pour affiner la liste des produits.",
    "Consultez les informations produit affichées pour chaque article.",
    "Vérifiez les photos ou détails QC s'ils sont disponibles.",
    "Comparez les options et vérifiez les informations actuelles avant d'acheter."
  ],

  // Article entry
  "articleEntry.title": "Commencez par notre guide complet",
  "articleEntry.body": "Nouveau sur la USFans Spreadsheet ? Lisez notre guide complet et original sur son fonctionnement, les conseils par catégorie, les contrôles QC, la livraison et la sécurité, écrit pour ceux qui veulent des informations claires et honnêtes.",
  "articleEntry.button": "Lire le guide complet",
  "articleEntry.meta": "Mis à jour régulièrement · Indépendant · Sans affiliation",

  // FAQ
  "faq.title": "Questions fréquentes",
  "faq.subtitle": "Réponses rapides aux questions les plus posées sur la USFans Spreadsheet.",
  "faq.items": [
    {
      "q": "Qu'est-ce que la USFans Spreadsheet ?",
      "a": "C'est une ressource de découverte et de recherche de produits qui organise les informations produits, les catégories et les liens pour que les acheteurs puissent rechercher des articles avant d'acheter."
    },
    {
      "q": "Comment utiliser la USFans Spreadsheet ?",
      "a": "Commencez par choisir une catégorie, puis utilisez la recherche et les filtres pour affiner les résultats, consultez les détails du produit et les informations QC, et comparez les options avant d'acheter."
    },
    {
      "q": "USFans est-il sûr à utiliser ?",
      "a": "La feuille elle-même est un outil de recherche. Vérifiez toujours indépendamment les informations sur le produit, le vendeur et le paiement, et méfiez-vous des faux sites et des liens suspects."
    },
    {
      "q": "Combien coûte la livraison USFans ?",
      "a": "Les frais de livraison varient selon le poids, les dimensions, la destination et la méthode. Les prix réels peuvent changer, vérifiez donc toujours les informations actuelles avant de commander."
    },
    {
      "q": "USFans propose-t-il des codes promo ?",
      "a": "Les promotions changent souvent. Nous n'inventons jamais de codes promo, alors vérifiez toujours toute offre actuelle sur le site officiel avant de l'utiliser."
    }
  ],

  // Final CTA
  "cta.title": "Prêt à explorer la USFans Spreadsheet ?",
  "cta.body": "Explorez nos guides, comparaisons, avis et ressources pour faciliter votre recherche USFans.",
  "cta.button": "Explorer USFans Spreadsheet",

  // Articles section
  "articles.title": "Derniers guides USFans",
  "articles.subtitle": "Des guides indépendants et originaux sur la USFans Spreadsheet, les avis, la livraison, l'entrepôt, le QC, les vendeurs et la sécurité.",
  "articles.read": "Lire",

  // Footer
  "footer.about": "USFansLink est un centre de ressources indépendant pour la USFans Spreadsheet. Nous publions des guides, des avis et des informations de sécurité pour aider les acheteurs à rechercher avec confiance.",
  "footer.resources": "Ressources",
  "footer.categories": "Catégories",
  "footer.languages": "Langues",
  "footer.disclaimer": "Ce site fournit des ressources informatives indépendantes. Nous ne garantissons pas l'authenticité, la sécurité, la légalité, la qualité, la disponibilité ni les performances d'un produit, vendeur, site web ou service tiers. Vérifiez toujours les informations actuelles de manière indépendante avant tout achat.",
  "footer.rights": "Tous droits réservés.",

  // Article page
  "article.backHome": "Retour à l'accueil",
  "article.tocTitle": "Table des matières",
  "article.updated": "Dernière mise à jour",
  "article.published": "Publié",
  "article.readTime": "min de lecture",
  "article.h1": "Guide USFans Spreadsheet : ce que c'est et comment l'utiliser",
  "article.intro": "La USFans Spreadsheet est une ressource de découverte et de recherche de produits utilisée par de nombreux acheteurs pour consulter des informations produits organisées, explorer des catégories et rechercher des articles avant d'acheter. Ce guide indépendant explique ce qu'est la feuille, comment elle fonctionne, comment l'utiliser et ce qu'il faut vérifier avant d'acheter.",
  "article.intro2": "Nous ne sommes affiliés à aucun vendeur ni magasin. Notre objectif est simple : vous aider à prendre de meilleures décisions grâce à des informations claires et honnêtes.",
  "article.toc": [
    "Qu'est-ce que la USFans Spreadsheet ?",
    "Comment fonctionne la USFans Spreadsheet",
    "Catégories de produits expliquées",
    "Comment utiliser la USFans Spreadsheet",
    "Conseils de recherche de produits et QC",
    "Les bases de la livraison et de l'entrepôt",
    "Conseils de sécurité avant d'acheter",
    "Questions fréquentes"
  ],
  "article.s1Title": "Qu'est-ce que la USFans Spreadsheet ?",
  "article.s1Text": "La USFans Spreadsheet est une ressource structurée qui rassemble les informations produits au même endroit. Au lieu de visiter de nombreuses pages séparées, les acheteurs peuvent consulter les produits, les catégories et les liens depuis une vue unique et organisée. Elle est couramment utilisée par les personnes qui recherchent des chaussures, des vêtements et des accessoires.",
  "article.s1Text2": "Il est important de comprendre que la feuille est un outil de recherche et de découverte, pas une boutique en soi. Elle renvoie vers des produits et des vendeurs, mais l'achat final et toute transaction ont lieu sur les sites vers lesquels elle pointe.",
  "article.s2Title": "Comment fonctionne la USFans Spreadsheet",
  "article.s2Text": "La feuille organise généralement les produits en lignes, chaque ligne affichant des détails tels que le nom du produit, la catégorie, les informations de prix et un lien vers l'annonce. Les filtres et la recherche vous aident à réduire une longue liste aux articles qui comptent pour vous.",
  "article.s2Text2": "Certaines versions incluent également des notes ou des photos de contrôle qualité (QC), qui vous donnent une vue plus précise d'un produit avant de vous engager. Considérez-les comme des références utiles et non comme des garanties : la qualité peut varier d'un article à l'autre.",
  "article.s3Title": "Catégories de produits expliquées",
  "article.s3Text": "Les produits sont généralement regroupés en catégories claires pour que vous trouviez plus vite ce dont vous avez besoin. Le tableau ci-dessous répertorie les principales catégories et ce qu'il faut rechercher dans chacune.",
  "article.s3Table.area": "Catégorie",
  "article.s3Table.what": "Ce qu'il faut vérifier",
  "article.s3Table.notes": "Notes",
  "article.s3Rows": [
    { "area": "Chaussures", "what": "Modèle, pointure, couleur et état", "notes": "Vérifiez la pointure et les photos QC" },
    { "area": "Sweats / Pulls", "what": "Coupe, matière et couleur", "notes": "Consultez les guides des tailles si disponibles" },
    { "area": "T-shirts", "what": "Taille, imprimé et matière", "notes": "Vérifiez les mesures" },
    { "area": "Vestes", "what": "Style, taille et saison", "notes": "Confirmez les détails avant de commander" },
    { "area": "Sacs et accessoires", "what": "Type, dimensions et couleur", "notes": "Consultez les descriptions des articles" }
  ],
  "article.s4Title": "Comment utiliser la USFans Spreadsheet",
  "article.s4Text": "Vous n'avez besoin d'aucun outil particulier pour utiliser la feuille efficacement. Un flux de travail simple et attentif suffit.",
  "article.s4Steps": [
    "Choisissez une catégorie qui correspond à ce que vous recherchez.",
    "Utilisez la recherche et les filtres pour affiner la liste des produits.",
    "Ouvrez un produit et lisez ses informations complètes.",
    "Vérifiez les photos ou notes QC lorsqu'elles sont disponibles.",
    "Comparez deux ou trois options avant de décider.",
    "Vérifiez le prix actuel, la disponibilité et les informations du vendeur."
  ],
  "article.s5Title": "Conseils de recherche de produits et QC",
  "article.s5Text": "Une bonne recherche de produit consiste à vérifier les détails plutôt qu'à se fier à une seule photo. Regardez plusieurs images, lisez attentivement la description et comparez le même produit entre plusieurs sources si possible.",
  "article.s5Text2": "Les photos QC vous montrent une vue plus précise de l'article réel, y compris les coutures, les étiquettes et les éventuelles marques visibles. Utilisez-les pour repérer tôt les problèmes évidents, mais rappelez-vous qu'une photo ne remplace pas la lecture complète de l'annonce.",
  "article.s6Title": "Les bases de la livraison et de l'entrepôt",
  "article.s6Text": "Le coût de livraison dépend de plusieurs facteurs, notamment le poids, les dimensions, la destination et la méthode d'expédition choisie. L'étape de l'entrepôt est celle où les produits peuvent être stockés, vérifiés et préparés avant de vous être envoyés.",
  "article.s6Text2": "Les prix et délais de livraison réels peuvent changer. Vérifiez toujours les tarifs et estimations de livraison actuels avant de commander, et gardez à l'esprit le suivi et les considérations douanières pour les commandes internationales.",
  "article.s7Title": "Conseils de sécurité avant d'acheter",
  "article.s7Text": "Restez prudent à chaque étape. Vérifiez que vous êtes sur le bon site, revérifiez les informations sur le vendeur et le produit, et évitez les liens suspects ou les messages non sollicités qui demandent des données personnelles.",
  "article.s7Text2": "Utilisez des méthodes de paiement sécurisées, conservez les registres de vos commandes et lisez les informations de remboursement ou de retour avant de payer. Si quelque chose semble suspect, arrêtez-vous et vérifiez de manière indépendante.",
  "article.faqTitle": "Questions fréquentes",
  "article.faq": [
    {
      "q": "La USFans Spreadsheet est-elle gratuite ?",
      "a": "La feuille est une ressource pour consulter les informations produits. Les détails d'accès peuvent varier, vérifiez donc les informations actuelles sur le site officiel."
    },
    {
      "q": "Puis-je faire confiance à tous les produits de la feuille ?",
      "a": "Non. La feuille organise les informations, mais vous devez toujours vérifier indépendamment les produits, les vendeurs et les paiements avant d'acheter."
    },
    {
      "q": "Comment vérifier les photos QC ?",
      "a": "Lorsque des photos QC sont disponibles, examinez les coutures, les étiquettes et les marques visibles, et comparez-les avec la description du produit."
    },
    {
      "q": "Que dois-je faire avant de commander ?",
      "a": "Confirmez le prix actuel, la disponibilité, les frais de livraison et les détails du vendeur, et lisez la politique de remboursement ou de retour avant de payer."
    }
  ],
  "article.relatedTitle": "Continuer la lecture",
  "article.relatedBody": "Envie d'en savoir plus ? Revenez à la page d'accueil pour parcourir les catégories de produits, découvrir nos ressources et trouver d'autres guides indépendants.",
  "article.ctaTitle": "Prêt à explorer la USFans Spreadsheet ?",
  "article.ctaBody": "Maintenant que vous comprenez son fonctionnement, ouvrez la USFans Spreadsheet et commencez à rechercher des produits en toute confiance.",
  "article.ctaButton": "Explorer USFans Spreadsheet",
  "article.author": "Équipe éditoriale USFansLink",
  "article.categoryLabel": "Guide",
  "article.notFoundTitle": "Page introuvable",
  "article.notFound": "Nous n'avons pas pu trouver cet article.",
  "notFound.title": "Page introuvable",
  "notFound.body": "La page que vous recherchez n'existe pas ou a été déplacée."
};